var moduleMap = {
	"./MenuItem": () => {
		return Promise.all([__webpack_require__.e("webpack_sharing_consume_default_vue_vue"), __webpack_require__.e("src_config_i18n_index_ts-src_config_router_index_ts-webpack_sharing_consume_default_single-sp-dc92ea"), __webpack_require__.e("webpack_sharing_consume_default_single-spa-vue_single-spa-vue"), __webpack_require__.e("webpack_sharing_consume_default_ui-kit_vue-wrapper_ui-kit_vue-wrapper"), __webpack_require__.e("src_components_foundations_layout-menu-item_export_ts-node_modules_jwt-decode_build_esm_index_js")]).then(() => (() => ((__webpack_require__("./src/components/foundations/layout-menu-item/export.ts")))));
	},
	"./App": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_primevue_button_index_mjs"), __webpack_require__.e("vendors-node_modules_vue-loader_dist_exportHelper_js-node_modules_primevue_dialog_index_mjs-n-a913b9"), __webpack_require__.e("vendors-node_modules_style-loader_dist_runtime_injectStylesIntoStyleTag_js-node_modules_style-6ca70b"), __webpack_require__.e("vendors-node_modules_css-loader_dist_cjs_js_node_modules_fontsource_lato_400_css-node_modules-bf29a9"), __webpack_require__.e("webpack_sharing_consume_default_vue_vue"), __webpack_require__.e("webpack_sharing_consume_default_tanstack_vue-query_tanstack_vue-query"), __webpack_require__.e("src_config_i18n_index_ts-src_config_router_index_ts-webpack_sharing_consume_default_single-sp-dc92ea"), __webpack_require__.e("src_init_ts-src_App_vue"), __webpack_require__.e("webpack_sharing_consume_default_single-spa-vue_single-spa-vue"), __webpack_require__.e("src_config_constants_environment_ts-src_main_ts-src_assets_main_scss")]).then(() => (() => ((__webpack_require__("./src/main.ts")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});